export default __webpack_public_path__ + "static/media/jamescitycounty-logo.fe0bbfab.jpg";